import React from 'react';
import { observer } from 'mobx-react';
import { ESPlusNotificationQRcodesList } from './ESPlusNotificationQRcodesList';
import { Catcher } from '../../Catcher';
import Styles from '../../styles/m_itemCardStyles.less';

export const ESPlusNotificationQRcodes: React.FC = observer(() => {
    return (
        <Catcher>
            <div className={Styles.main}>
                <ESPlusNotificationQRcodesList />
            </div>
        </Catcher>
    );
});
